/**
 * Created by ddodson on 1/19/16.
 */

/*
 * Decorate an action dispatch to dispatch an additional action to sync the URL state.
 */
import React from 'react';
import Analytics from '@climatecentral/analytics';
import { STATE } from '../reducers';
import { ABBREVIATIONS, OWL_EVENT_URL, STATE_NAME_ABBREVS, ZILLOW_MAP_URL } from '../config';
const d3 = require('d3');

const translations = require('../translations');
const FORM_KEY = "xohraeHahM1toong9Poh5Eij7no4geep";

export const cookieFieldMap = {
  "FirstName": "_ccssrf_name",
  "Organization": "_ccssrf_orgName",
  "phones[1].Value": "_ccssrf_orgType",
  "emails[0].Value": "_ccssrf_email"
};

/*
 * Sends a Google Analytics event.
 */
export function gaEvent(category, action, label, value) {
  const eventValues = { category };
  if (label !== undefined) {
    eventValues.label = String(label);
  }
  if (value !== undefined) {
    eventValues.value = String(value);
  }
  try {
    window.ga('send', 'event', category, action, label, value);
    Analytics.sendEvent(action, eventValues);
  } catch (error) {
    console.error(error);
  }
}

/*
 * Parses the location search string.
 */
export function parseURLParams() {
  var match,
    search = /([^&=]+)=?([^&]*)/g,
    decode = s => decodeURIComponent(s.replace(/\+/g, " ")),
    query  = location.search.substring(1);

  var urlParams = {};
  while (match = search.exec(query)) {
    urlParams[decode(match[1])] = decode(match[2]);
  }

  return urlParams;
}

export function parseURLPath() {
  const [ _, placeType, placeID ] = location.pathname.split("/");

  return {
    placeType,
    placeID
  }
}

export function sameLocationNewHash(hash) {
  return {pathname: location.pathname, search: location.search, hash: hash};
}

export function placeTypeSort(placeType) {
  const sortedTypes = {
    country: -1,
    state: 0,
    municipality: 1,
    county: 2,
    "postal-code": 3,
    "congressional-district": 4,
    "state-senate-district": 5,
    "state-assembly-district": 6,
  };
  return placeType in sortedTypes ? sortedTypes[placeType] : 1000000;
}

export function impactSort(waterLevel, byPct, a, b) {
  var aLvl = a.water_level_values[waterLevel.unit][waterLevel.level];
  var bLvl = b.water_level_values[waterLevel.unit][waterLevel.level];
  if (byPct) {
    return  aLvl / a.total > bLvl / b.total ? -1 : 1;
  } else {
    return  aLvl > bLvl ? -1 : 1;
  }
}

export const impactGroups = {
  Population: ['Population', 'Population_Jamaica', 'Population_Newprovidence', 'Population_Worldpop15', 'Population_Landscan10'],
  Housing: ['Housing', 'Housing_Newprovidence']
};

export const impactGroupsReverse = (function() {
  const obj = {};
  Object.keys(impactGroups).forEach(k => {
    impactGroups[k].forEach(v => {
      obj[v] = k;
    })
  });

  return obj;
})();

// FIXME: This should come from the database
export function placeTypeName(placeType, parentPlaceType) {
  if (placeType === "place") {
    if (parentPlaceType === "state") {
      return "Major city";
    } else {
      return "Municipality";
    }
  } else if (placeType === "postal-code") {
    return "ZIP code";
  } else if (placeType === "heritage-city") {
    return "Historic city";
  } else {
    return placeType
      .replace(/-/g, " ")
      .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }
}

export function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}

export function lowercase(str) {
  return str[0].toLowerCase() + str.slice(1);
}

export function pplural(phrase) {
  if (phrase.indexOf("population") !== -1) {
    return phrase.replace("population", "people");
  } else if (phrase.indexOf("Population") !== -1) {
    return phrase.replace("Population", "People");
  } else {
    return phrase;
  }
}

export function plural(word) {
  const irregulars = {
    population: "people",
    place: "cities/towns",
    parish: "parishes",
    islands: "islands"
  };

  if (word.toLowerCase() in irregulars) {
    return irregulars[word.toLowerCase()];
  }

  if (word[word.length - 1] === "y") {
    return word.slice(0, word.length - 1) + "ies";
  } else {
    return word + "s";
  }
}

export function singular(word) {
  if (word.slice(word.length - 3, word.length) === "ies") {
    return word.slice(word.length - 3) + "y";
  } else if (word[word.length - 1] === "s") {
    return word.slice(word.length - 2);
  }
}

export function commas(num) {
  const asFloat = parseFloat(num);
  if (asFloat > 1 && asFloat >= 1000) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return num.toString();
  }
}

export function toDecimal(str) {
  return str.match(/[0-9]+/)[0] / 10;
}

export function toFixed(x) {
  var e;
  if (Math.abs(x) < 1.0) {
    e = parseInt(x.toString().split('e-')[1]);
    if (e) {
      x *= Math.pow(10,e-1);
      x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
    }
  } else {
    e = parseInt(x.toString().split('+')[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10,e);
      x += (new Array(e+1)).join('0');
    }
  }
  return x;
}

/*
 * Inspects the location and returns a subset of the application state
 * Ensure that only legitimate application state keys are passed.
 */
export function locationToState() {
  const state = parseURLParams();
  //const { placeType, placeID } = parseURLPath();

  if ('unit' in state && 'level' in state) {
    state.waterLevel = {unit: state.unit, level: +state.level};
  }

  for (var key in state) {
    if (state.hasOwnProperty(key)) {
      if (!(key in STATE)) {
        delete state[key];
      }
    }
  }

  //state.place = {type: placeType, id: placeID};

  return state;
}

export function simplePlaceName(name) {
  return name.split(",")[0];
}

export function isUS(placeID) {
  return placeID.endsWith(".us") || placeID === "united-states";
}

export function isBangladesh(placeID) {
  return placeID.endsWith(".bd") || placeID === "bangladesh";
}

export function isEcuador(placeID) {
  return placeID.endsWith(".ec") || placeID === "ecuador";
}

export function isCaribbean(placeID) {
  return !isUS(placeID) && !isBangladesh(placeID) && !isEcuador(placeID);
}

export function isIDB(placeID) {
  return isCaribbean(placeID) || isEcuador(placeID);
}

export function getZoom(latCenter, lonCenter, bounds) {
  // Use a default zoom if we don't have bounds.
  if (!bounds) {
    return 12;
  }
  // The circumference of the Earth in KM.
  const C = 40075;

  var viewportWidth = 684;
  var viewportHeight= 500;

  var boundH = Math.abs(bounds[0] - bounds[2]) * 111.4;
  var boundW = Math.abs(bounds[1] - bounds[3]) * Math.cos(latCenter * (2 * Math.PI) / 360) * C / 360;

  var Sw = boundW / viewportWidth;
  var Sh = boundH / viewportHeight;
  var S = Math.max(Sw, Sh);

  var z = Math.floor(Math.log(C/S * Math.cos(latCenter * (2 * Math.PI) / 360)) / Math.log(2) - 8);

  return  z;
}

export function abbreviate(placeName) {
  const key = Object.keys(ABBREVIATIONS).find(name => placeName.indexOf(name) !== -1);
  if (key) {
    return placeName.replace(key, ABBREVIATIONS[key]);
  } else {
    return placeName;
  }
}

export function createDownloadLink(url, filename='') {
  const link = document.createElement('a');
  link.href = url;
  if (filename) {
    link.download = filename;
  }
  link.target = "_blank";
  return link;
}

export function clickLink(link) {
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
}

export function clickDownloadLink(url, filename='') {
  const link = createDownloadLink(url, filename);
  clickLink(link);
}

const getDataURL = async (url) => {
  const res = await fetch(url)
    .then((r) => {
      if (r.ok) return r;
      console.error('Error fetching dataURL', r);
    })
    .catch((error) => {
      console.error(error);
    });
  if (!res) return null;
  const blob = await res.blob();
  return URL.createObjectURL(blob);
};

export async function downloadImage(url, filename = 'riskfinder.png', callback) {
  const a = document.createElement('a');
  const dataURL = await getDataURL(url).then((res) => {
    if (res && res.length > 10) return res;
    return null;
  });
  if (!dataURL) {
    throw new Error('Failed to get a dataURL to download');
  }
  a.href = dataURL;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  if (callback) return callback(null, url);
  return dataURL;
}

export function downloadFile(url, filename, callback) {
  clickDownloadLink(url, filename);
  if (callback) {
    callback(null, url);
  }
}

export function stateAbbrev(placeType, placeID) {
  if (placeType === "state") {
    const stateStr = placeID.split(".")[0].replace(/-/g, " ");
    return STATE_NAME_ABBREVS[stateStr];
  } else {
    return placeID.split(".")[1].toUpperCase();
  }
}

export function abbrevLower(name) {
  const elems = name.split(" ");
  var lowerElems = [];
  elems.forEach(elem => {
    var capCount = 0;
    for (var i=0; i < elem.length; i++) {
      if (elem.charAt(i).toUpperCase() === elem.charAt(i)) {
        capCount += 1;
      }
      if (capCount >= 2) {
        break;
      }
    }
    if (capCount >=2) {
      return lowerElems.push(elem);
    } else {
      return lowerElems.push(elem.toLowerCase());
    }
  });

  return lowerElems.join(" ");
}

const scenarioOrder = ["Low", "lo", "intlo", "int", "Middle", "Medium", "med", "inthi", "hi", "High", "extreme"];
export function scenarioSort(a, b)  {
  const aIdx = scenarioOrder.indexOf(a.split("_")[1] || a);
  const bIdx = scenarioOrder.indexOf(b.split("_")[1] || b);

  if (aIdx > -1 && bIdx > -1) {
    if (aIdx < bIdx) {
      return -1
    } else {
      return 1
    }
  } else {
    if (a < b) {
      return -1
    } else {
      return 1
    }
  }
}

const modelOrder = ["NOAA (2017)", "National Research Council (2012)", "National Climate Assessment (2012/2014)",
  "Kopp et al. (2014): Probabilistic", "IPCC (2013)", "Army Corps of Engineers (2011)", "No global warming"];
export function modelSort(a, b) {
  if (modelOrder.indexOf(a) < modelOrder.indexOf(b)) {
    return -1;
  } else {
    return 1;
  }
}

export function getModel(forecastType) {
  const elements = forecastType.split("_");
  return elements[0];
}

export function getPathway(forecastType) {
  const elements = forecastType.split("_");
  return elements[1];
}

export function getModelRange(forecastType) {
  const model = getModel(forecastType);
  const pathway = getPathway(forecastType);
  const ranges = {
    default: [`${model}_lo`, `${model}_hi`],
    AR5: [`${model}_${pathway}_p17`, `${model}_${pathway}_p83`],
    BK: [`${model}_${pathway}_p05`, `${model}_${pathway}_p95`],
    DP16: [`${model}_${pathway}_p05`, `${model}_${pathway}_p95`],
    NCA: [`${model}_intlo`, `${model}_hi`],
    NOAA2017: [`${model}_intlo_p50`, `${model}_inthi_p50`],
    NRC: [`${model}_Low`, `${model}_High`],
  };
  return ranges[model] || ranges.default;
}

export function getLowAndHighPathways(forecastType) {
  const model = getModel(forecastType);
  const pathways = {
    AR5: { pathwayLow: 'AR5_RCP26_p17', pathwayHigh: 'AR5_RCP85_p83' },
    BK: { pathwayLow: 'BK_RCP26_p05', pathwayHigh: 'BK_RCP85_p95' },
    DP16: { pathwayLow: 'DP16_RCP26_p05', pathwayHigh: 'DP16_RCP85_p95' },
  };
  return pathways[model];
}

export function resolveForecastUnits(forecastData, unit) {
  const keys = ["Basic", "With mild flood", "With moderate flood", "With extreme flood"];
  keys.forEach(k => {
    const levels = forecastData[k].levels.filter(l => l.yVals.length > 0);
    if (levels.length === 1) {
      const level = levels[0];
      if (level.water_unit !== unit) {
        if (level.water_unit === "m") {
          level.yVals = level.yVals.map(num => +num * 3.28084);
          level.water_unit = "ft";
        } else if (level.water_unit === "ft") {
          level.yVals = level.yVals.map(num => +num * 0.3048);
          level.water_unit = "m";
        }
      }
    }
    forecastData[k].levels = levels;
  });

  return forecastData;
}

export function getWaterLevelUnit(waterLevel) {
  const units = {
    ft: waterLevel.level === 1 ? 'foot' : 'feet',
    m: waterLevel.level === 1 ? 'meter' : 'meters',
  };
  return units[waterLevel.unit];
}

export function ss2link(waterLevel, position, layer) {
  const lang = Transifex.live.getSelectedLanguageCode();
  return `http://ss2.climatecentral.org/#${position.zoom + 1}/${position.lat}/${position.lon}?show=${layer}&level=${waterLevel.level}&unit=${waterLevel.unit === "ft" ? "feet" : "meters"}&lang=${lang}`;
}

export function getZillowSS2link(position) {
  return `${ZILLOW_MAP_URL}/#${position.zoom + 1}/${position.lat}/${position.lon}`;
}

export function noaaExtremeLink(position, scenario) {
  return `http://xs.climatecentral.org/#${position.zoom + 1}/${position.lat}/${position.lon}?scenario=${scenario}`;
}

export function mappingChoicesLink(position, scenarioA, scenarioB) {
  // TODO: fix this so it's using the current language instead of the previous one
  // const lang = Transifex.live.getSelectedLanguageCode();
  // return `http://choices.climatecentral.org/#${position.zoom + 1}/${position.lat}/${position.lon}?scenario-a=${scenarioA}&scenario-b=${scenarioB}&lang=${lang}`;
  return `http://choices.climatecentral.org/#${position.zoom + 1}/${position.lat}/${position.lon}?scenario-a=${scenarioA}&scenario-b=${scenarioB}`;
}

export function newEnglandReport(stateAbbrev) {
  return ["RI", "MA", "NH", "ME", "CT"].indexOf(stateAbbrev) !== -1;
}

function encryptFormData(contactInfo) {
  const charVals = [];
  const formJSON = JSON.stringify(contactInfo);
  for (var i=0; i < formJSON.length; i++) {
    charVals.push(formJSON.charCodeAt(i) + (FORM_KEY.charCodeAt(i % FORM_KEY.length)));
  }

  return btoa(String.fromCharCode(...charVals));
}

function decryptFormData(encryptedContactInfo) {
  const charVals = [];
  const mappedString = atob(encryptedContactInfo);
  for (var i=0; i < mappedString.length; i++) {
    charVals.push(mappedString.charCodeAt(i) - (FORM_KEY.charCodeAt(i % FORM_KEY.length)));
  }

  return JSON.parse(String.fromCharCode(...charVals));
}

function readCookie() {
  var cookie = document.cookie;
  var cookieObj = {};
  cookie.split(";").map(function(s) {return s.replace(/^\s+|\s+$/g, '')}).forEach(function(kv) {
    var pairs = kv.split("=");
    cookieObj[pairs[0]] = pairs[1];
  });

  var contactInfo = "";
  for (var k in cookieObj) {
    if (k === "_ccssrf_form") {
      contactInfo = decryptFormData(cookieObj[k]);
      break;
    }
  }

  return contactInfo;
}

export function setContactCookie(contactInfo) {
  const now = new Date();
  var time = now.getTime();
  time += 14 * 24 * 60 * 60 * 1000; // 14 days from now
  now.setTime(time);
  const expiryDate = now.toUTCString();
  document.cookie = "_ccssrf_form=" + encryptFormData(contactInfo) + "; expires=" + expiryDate;
}

export function getContactCookie() {
  return readCookie();
}

export function shouldTranslate() {
  const selectedLanguage = Transifex.live.getSelectedLanguageCode();
  if (selectedLanguage !== Transifex.live.getSourceLanguageCode()) {
    return selectedLanguage;
  } else {
    return null;
  }
}

export function xlt(str) {
  try {
    if (shouldTranslate()) {
      return Transifex.live.translateText(str);
    } else {
      return str;
    }
  } catch (err) {
      return str;
  }
}

export function submitForm(url, data) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(data);
}

export function timeout(ms, promise) {
  return new Promise(function(resolve, reject) {
    setTimeout(function() {
      reject(new Error("timeout"));
    }, ms);
    promise.then(resolve, reject);
  })
}

export async function owlSend(eventObj) {
  await d3.json(OWL_EVENT_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(eventObj),
  });
}

export function slugify(string) {
  const a = 'àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';
  const b = 'aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';
  const p = new RegExp(a.split('').join('|'), 'g');
  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with ‘and’
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple — with single -
    .replace(/^-+/, '') // Trim — from start of text
    .replace(/-+$/, ''); // Trim — from end of text
}

export function shrinkFont(textBox, maxLines, maxWidth) {
  const textWidth = textBox.getComputedTextLength();
  const segmentWidth = textWidth / maxLines;
  if (segmentWidth > maxWidth) {
    textBox.style.fontSize = (maxWidth / segmentWidth) + 'em';
  }
}

export function verticalWrap(textBox, maxWidth) {
  const text = d3.select(textBox);
  const lineHeight = 1.2; // ems
  const x = text.attr('x');
  const y = text.attr('y');
  const dy = parseFloat(text.attr('dy'));
  const words = text.text().split(/\s+/).reverse();
  let word;
  let line = [];
  let lineNumber = 0;
  let tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('dy', dy + 'em');
  while (word = words.pop()) {
    line.push(word);
    tspan.text(line.join(' '));
    if (tspan.node().getComputedTextLength() > maxWidth) {
      line.pop();
      tspan.text(line.join(' '));
      line = [word];
      tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
    }
  }
  text.attr('y', ++lineNumber * y);
}

export async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export function togglePanel(event) {
  event.target.classList.toggle('open-panel');
  const content = event.target.nextElementSibling;
  if (content.style.maxHeight){
    content.style.maxHeight = null;
  } else {
    content.style.maxHeight = content.scrollHeight + "px";
  }
}

export function shrinkWrapYAxis(textBox, maxLines, maxWidth) {
  shrinkFont(textBox, maxLines, maxWidth);
  verticalWrap(textBox, maxWidth);
}

export function getGeoContexts(placeID, placeType) {
  const contexts = {
    county: ['peer', 'place', 'postal-code'],
    state: ['congressional-district', 'county', 'place'],
  };
  if (placeID === 'district-of-columbia.us') {
    contexts.state = ['county', 'place'];
  }
  return contexts[placeType] || ['peer'];
}

async function getSSIDRegionNameInfo(ssId) {
  const url = `/api/metadata/names/ss_id/${ssId}`;
  return await d3.json(url);
}

async function getSSRF2RegionNameInfo(placeID, placeType) {
  const url = `/api/metadata/names/ssrf2_id/${placeType}/${placeID}`;
  return d3.json(url);
}

async function getSSRF2RegionName(placeID, placeType) {
  const url = `/api/metadata/name/ssrf2_id/${placeType}/${placeID}`;
  return d3.json(url);
}

export function getContainerID(geoObjects) {
  const geoObjKeys = Object.keys(geoObjects);
  return geoObjKeys.includes('boundary') ? geoObjKeys.filter((k) => k !== 'boundary')[0] : '';
}

function getPlaceTypeLabel(geoObjects, placeType) {
  const labels = {
    'congressional-district': 'congressional district',
    'place': Object.keys(geoObjects).includes('City') ? 'major city' : 'town',
    'postal-code': 'zip code',
  }
  return labels[placeType] || placeType;
}

export async function getPlaceTypeOptions(geoData, placeID, placeType) {
  const options = [];
  for (let geoType of Object.keys(geoData)) {
    let containerName, nameInfo;
    const geoObjects = geoData[geoType].objects;
    const containerID = getContainerID(geoObjects);
    if (containerID) {
      nameInfo = await getSSIDRegionNameInfo(containerID);
      containerName = nameInfo.region_name;
    } else if (geoType === placeType) {
      nameInfo = await getSSRF2RegionNameInfo(placeID, placeType);
      containerName = nameInfo.parent_name;
    } else {
      nameInfo = await getSSRF2RegionName(placeID, placeType);
      containerName = nameInfo.region_name;
    }
    const placeTypeLabel = getPlaceTypeLabel(geoObjects, geoType);
    options.push({containerName, placeTypeLabel, placeTypeValue: geoType});
  }
  return options;
}

export function formatZillowValue(value, zillowVarType, zillowIsPct=false, zillowEndYr='2017') {
  const val = value === null ? null : parseFloat(value);
  const growthStr = `recent growth (<var>2010-${zillowEndYr}</var>)`;
  if (zillowVarType === 'Growth') {
    return val === Infinity ? `All ${growthStr} has been in the risk zone` : val === 0 ? `All ${growthStr} has been in the safer zone` : val === null ? `No ${growthStr}` : `${parseFloat(val).toFixed(1)}x`;
  } else if (zillowIsPct) {
    return `${val.toFixed(1)}%`;
  } else {
    const roundedVal = val < 1 ? val.toPrecision(1) : val.toFixed(0);
    return zillowVarType === 'Zestimate' ? '$' + commas(roundedVal) : commas(roundedVal);
  }
}

export function elevMeta(placeID) {
  if (isUS(placeID)) {
    return {
      name: 'lidar',
      url: 'https://coast.noaa.gov/digitalcoast/data/coastallidar.html'
    }
  } else if (isCaribbean(placeID)) {
    return {
      name: 'Climate Central\u0027s CoastalDEM\u2122',      // apostrophe and TM symbol, unicode
      url: 'http://sealevel.climatecentral.org/uploads/research/CoastalDEMv1.1-Brief.pdf'
    }
  } else {
    return {
      name: 'NASA SRTM v3',
      url: 'https://earthdata.nasa.gov/nasa-shuttle-radar-topography-mission-srtm-version-3-0-global-1-arc-second-data-released-over-asia-and-australia'
    }
  }
}

export function boundaryMetaCatGeo(metadata, comparisons, comparisonType) {
  const legacyPtypePair = comparisons.find((pair) => pair[0] === comparisonType);
  if (legacyPtypePair && legacyPtypePair[1] in metadata.geography) {
    const meta = metadata.geography[legacyPtypePair[1]];
    return meta.boundary_source;
  } else {
    return {
      "name": "Error: source not available",
      "mouseover": "",
      "url": ""
    }
  }
}

export function boundaryMetaSimplified() {
  // TODO FIXME: don't use hardcoded value
  return {
    name: "GADM 2.0",
    mouseover: "Global Administrative Areas 2.0",
    url: "http://www.gadm.org/"
  }
}

export function boundaryMeta(metadata, comparisons, comparisonType) {
  if (metadata.simplified === true) {
    return boundaryMetaSimplified();
  } else {
    return boundaryMetaCatGeo(metadata, comparisons, comparisonType);
  }
}

export function getDefaultZillowPlaceType(placeType) {
  const defaultPlaceTypes = {
    country: 'state',
    county: 'postal-code',
    state: 'county',
  };
  return defaultPlaceTypes[placeType] || placeType;
}

export function getZillowEndYr(placeID) {
  let endYr = '2017';

  const endYr2005 = [
    'district-of-columbia.us',
    '.dc.us',
  ];
  const endYr2016 = [
    'alabama.us',
    '.al.us',
    'florida.us',
    '.fl.us',
    'mississippi.us',
    '.ms.us',
    'new-york.us',
    '.ny.us',
  ];

  endYr2005.forEach((place) => {
    if (placeID.endsWith(place)) {
      endYr = '2005';
    }
  });
  endYr2016.forEach((place) => {
    if (placeID.endsWith(place)) {
      endYr = '2016';
    }
  });

  return endYr;
}

export function getModelText(model) {
  const modelText = {
    DP16: 'Kopp et al. 2017',
    BK: 'Kopp et al. 2014',
  };
  return modelText[model];
}

export function getModelReference(model) {
  const modelRef = {
    DP16: 'Kopp, R. E., DeConto, R. M., Bader, D. A., Hay, C. C., Horton, R. M., Kulp, S., Oppenheimer, M., Pollard, D. and Strauss, B. H.\n(2017), Evolving Understanding of Antarctic Ice-Sheet Physics and Ambiguity in Probabilistic Sea-Level Projections.\nEarth\'s Future, 5: 1217-1233. doi:10.1002/2017EF000663',
    BK: 'Kopp, R. E., Horton, R. M., Little, C. M., Mitrovica, J. X., Oppenheimer, M., Rasmussen, D. J., Strauss, B. H. and Tebaldi, C.\n(2014), Probabilistic 21st and 22nd century sea-level projections at a global network of tide-gauge sites.\nEarth\'s Future, 2: 383-406. doi:10.1002/2014EF000239',
  }
  return modelRef[model];
}

export function getModelHref(model) {
  const modelHref = {
    DP16: 'https://agupubs.onlinelibrary.wiley.com/doi/abs/10.1002/2017EF000663',
    BK: 'https://agupubs.onlinelibrary.wiley.com/doi/abs/10.1002/2014EF000239',
  };
  return modelHref[model];
}

export function getModelLink(model) {
  return <a href={getModelHref(model)} target="_blank"><var>{getModelText(model)}</var></a>;
}

export function getScenarioText(pathway) {
  const scenarioText = {
    RCP26: 'extreme cuts in heat-trapping pollution (RCP 2.6)',
    RCP45: 'moderate cuts in heat-trapping pollution (RCP 4.5)',
    RCP85: 'no cuts in heat-trapping pollution (RCP 8.5)',
  };
  return scenarioText[pathway];
}

export function getProbText(prob) {
  const probText = {
    p05: '5th percentile (low-sensitivity)',
    p50: '50th percentile (mid-sensitivity)',
    p95: '95th percentile (high-sensitivity)',
  };
  return probText[prob];
}

export function getScenarioDescription(model, pathway, prob) {
  const modelLink = getModelLink(model);
  const scenarioDescr = getScenarioText(pathway);
  const probDescr = getProbText(prob);
  return <span>{xlt(probDescr)} sea-level rise projections based on {modelLink} assuming {xlt(scenarioDescr)}.</span>;
}
